var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 64,
    viewBox: "0 0 110 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.948985,
    x: 112.943,
    y: 35.8737,
    width: 109.986,
    height: 40.0644,
    rx: 20.0322,
    transform: "rotate(163.763 112.943 35.8737)",
    fill: "#2F80ED",
    stroke: "#111111",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/Pill.2c113e7a4170c48b0ac04efea5538a42.svg";
export { ForwardRef as ReactComponent };